exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".notification-list .dropdown-content.open { display:block; opacity:1; }\n.help-list .button {\n  position: relative;\n  padding-right: 0px !important;\n}\n.mat-autocomplete-panel-search{\n  width: 500px !important;\n}\n.mat-autocomplete-panel-search .mat-option-search {\n  line-height: 15px !important;\n}\n.search-box .autocomplete-result {\n  display: block !important;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/login.theprintlife.com/src/app/mnt-master/master-layout/master-layout.component.css
// module id = ../../../../../src/app/mnt-master/master-layout/master-layout.component.css
// module chunks = main